module.exports = __webpack_public_path__ + "static/media/10 REGGIANA CALCIO Casa del Fascio Ospizio.527a9445.svg";